/**
 * Splits a string into three parts: First Sentence, Middle Part, and Last Sentence.
 * Supports international sentence boundaries (Japanese, Arabic, Hindi, etc.)
 */
export const splitIntroMessage = (
  text: string | undefined,
  locale: string = 'en-US'
): {first: string; middle: string; last: string} => {
  if (!text) return {first: '', middle: '', last: ''}

  const cleanText = text.replace(/[{}[\]|&*_]/g, '').trim()
  let sentences: string[] = []

  try {
    // Check if the browser supports Segmenter
    if (typeof Intl !== 'undefined' && (Intl as any).Segmenter) {
      const segmenter = new (Intl as any).Segmenter(locale, {
        granularity: 'sentence',
      })
      const segments = Array.from(segmenter.segment(cleanText))

      // We cast 's' to any or the specific SegmentData interface to satisfy TS
      sentences = segments.map((s: any) => s.segment?.trim()).filter(Boolean)
    } else {
      throw new Error('Intl.Segmenter not supported')
    }
  } catch (e) {
    // Fallback logic for environments without Segmenter
    sentences = cleanText
      .split(/([.!?。！？।]\s*)/g)
      .reduce((acc: string[], curr, i) => {
        if (i % 2 === 0) acc.push(curr)
        else if (acc.length > 0) acc[acc.length - 1] += curr
        return acc
      }, [])
      .map((s) => s.trim())
      .filter(Boolean)
  }

  const first = sentences.length > 0 ? sentences[0] : ''
  const last = sentences.length > 1 ? sentences[sentences.length - 1] : ''
  const middle = sentences.length > 2 ? sentences.slice(1, -1).join(' ') : ''

  return {first, middle, last}
}
